var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"form-inline\" ng-style=\"formStyle\" ng-submit=\"$parent.submit()\"\u003E\u003Cinput class=\"form-control\" id=\"email\" type=\"email\" required ng-model=\"$parent.email\" ng-style=\"inputStyle\" placeholder=\"{{emailplaceholder}}\"\u003E\u003Cbutton class=\"btn\" type=\"submit\" ng-style=\"buttonStyle\"\u003E{{buttontext}}\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/directives/email-form/email-form.jade
// module id = 723
// module chunks = 1